import React, { useEffect, useState } from "react";
import CustomButton from "../../components/CustomButton";
import '../../assets/css/ApproveOrDenyRequest.css';
import '../../assets/css/Custom.css';
import ballImage from '../../assets/images/ballImage.png';
import participantImage from '../../assets/images/participantImage.png';
import { MdPeopleOutline } from "react-icons/md";
import { CiLocationArrow1 } from "react-icons/ci";
import Layout from '../../layouts/Layout.js';
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";
import message from '../../assets/images/messages.png';
import { apiHandler } from "../../assets/api/index.js";
import { endpoint } from "../../assets/api/endpoint.js";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import GameInvitation from "../../components/GameInvitation.js";
import LeaveGameModal from "../../components/LeaveGame.js";
import { CiCalendarDate } from "react-icons/ci";
import { FaDollarSign } from "react-icons/fa";
import { TbTimeDuration60 } from "react-icons/tb";
import GoogleMapComponent from "../../components/GoogleMap.js";
import { MdAccessTime } from "react-icons/md";
import PaymentModal from "../../components/PaymentModal.js";
import { RxCross2 } from "react-icons/rx";
import { IoIosArrowDropleft } from "react-icons/io";
import { IoLocationOutline } from "react-icons/io5";

const ApproveOrDenyRequest = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const notificationData = state?.notificationData || [];
    const gameId = state?.gameId;
    const keyId = state?.keyId;
    const [acceptedParticipants, setAcceptedParticipants] = useState({});
    const { accessToken, saveCardDetailData } = useSelector((state) => state.loginInfo);
    const [close, setClose] = useState(false)
    const [leaveGame, setLeaveGame] = useState(false)
    const [isModalVisible, setModalVisible] = useState(true);
    const filteredData = notificationData.find(item => item.id === keyId);
    const additionalData = filteredData?.additionalData || {};
    const participants = additionalData?.participants || [];
    const [distance, setDistance] = useState();
    const [isOpen, setIsOpen] = useState(true);
    const [courtData, setCourtData] = useState([{}]);
    const [formData, setFormData] = useState();
    const [errors, setErrors] = useState();
    


    const onGoToBackPage = () => {
        navigate(-1);
    };

    const onClose = () => {
        setClose(false)
    }

    useEffect(() => {
        const data = {
            "notificationIds": [keyId]
        }
        const fetchData = async () => {
            const result = await apiHandler({
                url: endpoint.MARK_SEEN,
                method: "POST",
                data: data,
                authToken: accessToken?.accessToken,
            });
            if (result.data.message) {
                toast.success(result.data.message);
            } else {
                toast.error('Something went wrong');
            }
        }
        if (!filteredData.seen && filteredData.type != 'Selection By Host') {
            fetchData()
        }
           setCourtData([{ longitude: filteredData?.additionalData?.coordinates?.longitude, latitude: filteredData?.additionalData?.coordinates?.latitude, courtName: filteredData?.additionalData?.courtName }])
    }, [filteredData])

    const gameInfoItems = [
        {
            icon: <MdPeopleOutline style={{ color: "#006FFD" }} />,
            text: ` ${additionalData.requiredPlayers - additionalData.currentPlayers || 0} slots available`,
        },
        {
            icon: <IoLocationOutline style={{ color: "#006FFD" }} />,
            text: additionalData.courtName || "Court Name",
        },
        {
            icon: <MdPeopleOutline style={{ color: "#006FFD" }} />,
            text: `${additionalData.currentPlayers || 0} players`,
        },
        {
            icon: <FaDollarSign style={{ color: "#006FFD" }} />,
            text: `${additionalData.courtPrice} per player`,
        },
    ];

    const aboutGameInfo = [
        { title: "Court Name", subTitle: additionalData.courtName },
        { title: "Game Host", subTitle: additionalData.hostName },
        {
            title: "Description", subTitle: additionalData.gameDescription
        },
    ];

    const toggleModal = () => {
        setIsOpen(!isOpen);
    };

    function getDistanceFromCurrentLocation(targetLatitude, targetLongitude) {
        return new Promise((resolve, reject) => {
            if (!navigator.geolocation) {
                reject("Geolocation is not supported by your browser.");
                return;
            }

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    const toRadians = (degrees) => degrees * (Math.PI / 180);
                    const R = 6371; // Earth radius in km
                    const dLat = toRadians(targetLatitude - latitude);
                    const dLon = toRadians(targetLongitude - longitude);

                    const a =
                        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                        Math.cos(toRadians(latitude)) *
                        Math.cos(toRadians(targetLatitude)) *
                        Math.sin(dLon / 2) * Math.sin(dLon / 2);

                    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                    const distanceInKm = R * c;
                    const distanceInMiles = distanceInKm * 0.621371;
                    resolve(distanceInMiles.toFixed(2) + " miles");
                },
                (error) => {
                    reject("Error getting current location: " + error.message);
                }
            );
        });
    }

    useEffect(() => {
        getDistanceFromCurrentLocation(additionalData.coordinates.longitude, additionalData.coordinates.latitude)
            .then((distance) => setDistance(distance))
            .catch((error) => console.error(error));
    }, [])

    const leaveGameFunc = () => {
        if (saveCardDetailData?.userConfgis?.isEligibleForService) {
            setIsOpen(!isOpen);
        }
        else {
            setLeaveGame(true)
        }
    }

    const handleCloseModal = () => {
        setModalVisible(false);
    };

    if (!isModalVisible) return null;

    const handleCourtSelectFromMap = (court) => {
        setFormData((prev) => ({
            ...prev,
            courtName: court?.courtName
        }));

        if (errors?.courtName) {
            setErrors({
                ...errors,
                courtName: ""
            });
        }
    };

    return (
        <>
            {filteredData.type != 'Game Invitation' ?
                <>
                    <Layout>
                        <div className="container">
                            <div className="d-flex justify-content-start mt-4">
                                <CustomButton
                                    className="back-page-btn"
                                    onClick={onGoToBackPage}
                                    buttonText={
                                        <>
                                            <IoIosArrowDropleft className="me-3" style={{ cursor: 'pointer', fontSize: '31px' }} /> Back
                                        </>
                                    }
                                />
                            </div>

                            <div className="row mt-3 mb-3">
                                {/* Left Section: Game Details */}
                                <div className="col-lg-6" style={{ boxShadow: 'rgba(96, 97, 112, 0.16) 0px 2px 4px', borderRadius: '10px', padding: '25px', background: 'white' }}>
                                    <div className="d-flex justify-content-between py-2">
                                        <div className="game-txt fs-4" style={{ fontWeight: '600' }}>
                                            <img src={ballImage} width="30px" height="30px" className="me-3" alt="Game" />
                                            {additionalData.gameName || "Game Name"}
                                        </div>
                                        <div className="single-txt">{additionalData.singularity || "Type"}</div>
                                    </div>

                                    <div className="d-flex justify-content-between mt-3">
                                        <CustomButton buttonText={additionalData.level || "Level"} className="custom-beginer-button text-upper" />
                                        <CustomButton buttonText={additionalData.sportName?.toUpperCase() || "SPORT"} className="custom-beginer-button text-upper" />
                                    </div>

                                    <div className="mt-3">
                                        <span className={`approve-circle-${additionalData.status?.toLowerCase()}`}></span>
                                        <span className="active-txt">{additionalData.status || "Status"}</span>
                                    </div>

                                    <div className="container py-4">
                                        <div className="game-info-txt fs-5" style={{ color: "#71727A" }}>
                                            Game Information
                                        </div>
                                        <div className="row mt-3" style={{ rowGap: '15px' }}>
                                            {gameInfoItems.map((item, index) => (
                                                <div className="col-md-6" key={index}>
                                                    <div className="d-flex align-items-center p-1">
                                                        {item.icon}
                                                        <span className="approve-or-deny-game-info-txt ms-2">{item.text}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="row mt-4">
                                            {aboutGameInfo?.map((item, index) => (
                                                <div className={`col-md-6 ${aboutGameInfo.length === 1 || (aboutGameInfo.length % 2 !== 0 && index === aboutGameInfo.length - 1) ? "col-lg-12" : ""} `} key={index}>
                                                    <div className="">
                                                        <h3 className="approve-or-deny-title">{item.title}</h3>
                                                        <p className="approve-or-deny-subtitle ">{item.subTitle}</p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-6">
                                    <div style={{ boxShadow: 'rgba(96, 97, 112, 0.16) 0px 2px 4px 0px', borderRadius: '10px' }}>
                                        <GoogleMapComponent height={'300px'} courtData={courtData} onCourtSelect={handleCourtSelectFromMap} />
                                    </div>

                                    <div className="border p-3 mt-3" style={{ boxShadow: 'rgba(96, 97, 112, 0.16) 0px 2px 4px', borderRadius: '10px', background: 'white' }}>
                                        <div className="ps-2">
                                            <span className="approve-or-deny-game-info-txt">Participants</span>: {`${participants.length} Out of ${additionalData.requiredPlayers}`}
                                        </div>

                                        <div className="row">
                                            {participants.map((participant, index) => (
                                                <div className="col-md-12 d-flex align-items-center justify-content-between px-3 mb-2" key={index}>
                                                    <div className="d-flex align-items-center p-2">
                                                        <img
                                                            src={participant.avatarUrl || participantImage}
                                                            alt={participant.name}
                                                            className="border border-dark rounded-0"
                                                            width="50"
                                                            height="50"
                                                        />
                                                        <div className="ms-3">
                                                            <strong className="text-primary">{participant.name}</strong>
                                                            {participant.skillLevel && <div>({participant.skillLevel})</div>}
                                                        </div>
                                                    </div>
                                                    {participant.name !== additionalData.hostName && (
                                                        <img src={message} alt="message-icon" />
                                                    )}
                                                </div>
                                            ))}
                                        </div>

                                        <div className="mb-2 text-center">
                                            <CustomButton
                                                buttonText="Leave The Game"
                                                className="border"
                                                onClick={leaveGameFunc}
                                                style={{
                                                    width: '70%',
                                                    height: '48px',
                                                    borderRadius: '12px',
                                                    background: '#FF616D',
                                                    color: '#FFFFFF',
                                                    marginTop: '25px',
                                                }}
                                            />
                                            {leaveGame && <LeaveGameModal onClose={handleCloseModal} filteredData={filteredData} />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Layout>
                </>
                :
                <>
                    {saveCardDetailData?.userConfgis?.isEligibleForService ?
                        <GameInvitation onClose={onClose} filteredData={filteredData} />
                        :
                        <div>
                            <div className={`modal-overlay  ${isOpen ? "open" : "closeModal"} `} style={{ width: "100%", height: "500px" }}>
                                <div className="modal-content">
                                    <button onClick={toggleModal} className="close-button">
                                        <RxCross2 className="fs-4" />
                                    </button>
                                    <PaymentModal PaymentWay={"notification"} gameId={gameId} />
                                </div>
                            </div>
                        </div>

                    }
                </>
            }

        </>
    );
};

export default ApproveOrDenyRequest;
